import { CurrencyAmount } from '~/components/component-library'
import { SponsoredBadge } from '~/components/txn-display/cost-display/SponsoredBadge'
import { cn } from '~/utils/tailwind-utils'

type SponsoredFeeAmountProps = {
  cost: number
  isSponsored: boolean
  hideBadgeText?: boolean
  // Who covered the gas, from useGasPaidByLabel. Unknown before submission.
  paidBy?: string
}

export const SponsoredFeeAmount = ({
  cost,
  isSponsored,
  hideBadgeText = false,
  paidBy,
}: SponsoredFeeAmountProps) => (
  <>
    {isSponsored ? (
      <SponsoredBadge hideText={hideBadgeText} label={paidBy ?? 'Sponsored'} />
    ) : (
      paidBy && <span className="text-secondary">{paidBy}</span>
    )}
    <span
      className={cn({
        'text-secondary line-through': isSponsored,
      })}
    >
      ~<CurrencyAmount layout="inline" value={cost} />
    </span>
  </>
)
